<template>
  <div class="document-content" v-loading="loading">
    <!-- 搜索 -->
    <div style="position: relative;">
      <div class="document-search">
        <search
          @search="search"
          placeholder="搜索标题、正文"
          :isShowHistory="true"
        ></search>
        <Course name="doc" />
      </div>
    </div>
    <!-- 菜单栏 -->
    <div class="document-nav clear">
      <div class="document-nav-left fl">
        <div class="nav-name">
          <span class="doc-name">{{ docName || "默认文集" }}</span>
          <span class="document-count">({{ rowCount }}篇)</span>
        </div>
      </div>
      <div class="document-nav-right fr">
        <el-checkbox v-model="checked" @change="changevalue"></el-checkbox>
        <span class="ml5 selectall">全部选中</span>
        <span class="ml10 border cursor move">
          <el-dropdown :hide-on-click="false" @command="move">
            <span class="defaultsize">
              移动到<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              :append-to-body="false"
              ref="folderdrop"
            >
              <el-dropdown-item
                class=""
                :command="item.folderId"
                v-for="item in folder"
                :key="item.folderId"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <span ref="folder" id="folder-drop"></span>
        <span
          class="ml10 border cursor defaultsize batchdelete"
          @click="batchdelete"
          >批量删除</span
        >
        <!-- <span class="ml15 border cursor">
          <el-dropdown :hide-on-click="false">
            <span class="defaultsize">
              导入文章<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>百度</el-dropdown-item>
              <el-dropdown-item>知乎</el-dropdown-item>
              <el-dropdown-item>头条</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown></span
        > -->

        <span class="ml10 border cursor order-active">
          <el-dropdown :hide-on-click="false" @command="order">
            <span class="defaultsize">
              {{ timeText }}<i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              :append-to-body="false"
              ref="orderdrop"
            >
              <el-dropdown-item
                v-for="(item, index) in time"
                :command="item.name"
                :key="index"
                :class="{ orderItemActive: item.name === timeText }"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </span>

        <span ref="order" id="order-drop"></span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="document-content-list">
      <el-row :gutter="20" style="margin-top: 2px;margin-left: -8px">
        <el-col :span="4.8">
          <documentcard :empty="true"></documentcard>
        </el-col>
        <el-col :span="4.8" v-for="(item, index) in list" :key="index">
          <documentcard
            :item="item"
            :empty="false"
            @deleteDoc="deleteDoc"
            style="margin-bottom:20px"
          ></documentcard>
        </el-col>
      </el-row>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="rowCount"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          @current-change="getList"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>

    <!-- 登录提示 -->
    <div class="document-dialog" v-if="isShowLogin">
      <el-dialog
        :visible.sync="isShowLogin"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px"
        :show-close="false"
        :close-on-click-modal="false"
      >
        <div slot="title" class="dialog-title ml5 left">账号登录</div>
        <div class="login-tip">您当前暂未登录账号，请先登录账号!</div>
        <div slot="footer" class="dialog-footer ml5 center">
          <el-button size="mini" class="dialog-tologin" @click="tologin"
            >去登陆</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import documentcard from "../components/share/DocumentCard";
import search from "../components/share/Search";
import Course from "@/components/share/Course";
import { mapActions, mapMutations, mapState } from "vuex";
// import Cookies from "js-cookie";
export default {
  props: ["folder"],
  components: { search, documentcard, Course },
  data() {
    return {
      loading: false,
      docName: this.$route.params.docName || "",

      rowCount: 0,
      pageIndex: 1,
      pageSize: 15,
      isShowLogin: false,
      isShowDeleteDocument: false,
      isShowNew: false,
      checkedAll: false,
      documentName: "",
      list: [],
      title: "", //文集列表参数title
      content: "", //文集列表参数content

      time: [
        {
          text: "UpdateTime|DESC",
          name: "最近更新"
        },
        {
          text: "Addtime|ASC",
          name: "最早创建"
        },
        {
          text: "AddTime|DESC",
          name: "最近创建"
        },
        {
          text: "UpdateTime|ASC",
          name: "最早更新"
        }
      ],
      timeText: "最近更新",
      sortColumn: "UpdateTime",
      sortType: "DESC"
    };
  },
  computed: {
    ...mapState("home", {
      folderList: ["folder"],
      saveState: ["saveState"],
      saveLoading: ["saveLoading"]
    }),
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    },
    checked: {
      get() {
        if (this.list != null && this.list.length > 0) {
          var trueList = this.list.filter(m => m.ischecked === true);
          return trueList.length === this.list.length;
        } else {
          return false;
        }
      },
      set() {
        if (this.list != null && this.list.length > 0) {
          var trueList = this.list.filter(m => m.ischecked === true);
          return trueList.length === this.list.length;
        } else {
          return false;
        }
      }
    }
  },

  watch: {
    async $route(to) {
      this.docName = to.params.docName;
      // var folderResult = await this.AFolder();
      // // alert(1);
      // this.setfolder(folderResult.data);
      this.getList(1);
    },
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "document-content-list", 32, "class");
      }
    }
  },
  methods: {
    ...mapActions("api", ["ADoc", "ADocDel", "ADocMove", "AFolder"]),
    ...mapMutations("home", ["setfolder", "setSaveState", "setSaveLoading"]),
    search(keyword) {
      this.title = keyword;
      this.content = keyword;
      this.getList(1);
    },
    getFolderId() {
      var _this = this;
      var folderId = 0;
      var folderList = this.folder.filter(m => m.name === _this.docName);
      if (folderList.length <= 0) {
        return folderId;
      }
      return folderList[0].folderId;
    },
    async getList(pageIndex) {
      this.loading = true;
      if (this.saveLoading) {
        let addType = setInterval(async () => {
          if (this.saveState) {
            clearInterval(addType);
            let type = false;
            this.setSaveState(type);
            this.setSaveLoading(type);
            this.loadDocList(pageIndex);
          }
        }, 300);
      } else {
        this.loadDocList(pageIndex);
      }
    },
    loadDocList(pageIndex) {
      setTimeout(async () => {
        var result = await this.ADoc({
          pageIndex,
          pageSize: this.pageSize,
          FolderId: this.getFolderId(),
          title: "",
          content: "",
          titleOrContent: this.title,
          sortColumn: this.sortColumn,
          sortType: this.sortType
        });
        this.loading = false;
        if (result.errorCode === 0) {
          var list = result.data.dataSource;
          if (list != null) {
            list.forEach(value => {
              value["ischecked"] = false;
            });
            this.list = list;
          }
          this.rowCount = result.data.rowCount;
        } else {
          this.$message({
            showClose: true,
            message: result.errorMess,
            type: "error"
          });
        }
      }, 600);
    },
    tologin() {
      this.$router.push({ path: "/materialcollection" });
      this.isShowLogin = false;
    },
    changevalue(val) {
      if (this.list != null && this.list.length > 0) {
        this.list.forEach(m => (m.ischecked = val));
      }
    },
    //移动
    async move(folderId) {
      var trueList = [];
      this.list.forEach(m => {
        if (m.ischecked == true) {
          trueList.push(m.docId);
        }
      });
      if (trueList.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择需要移动的文集",
          type: "warning"
        });
        return;
      }
      var _this = this;

      var oldFolderId = 0;
      if (_this.docName) {
        var folderList = this.folder.filter(m => m.name == _this.docName);
        if (folderList.length <= 0) {
          this.$message({
            showClose: true,
            message: "找不到需要移动的文件夹",
            type: "warning"
          });
          return;
        }
        oldFolderId = folderList[0].folderId;
      }

      var result = await this.ADocMove({
        docIdList: trueList.join("|"),
        newFolderId: folderId,
        oldFolderId: oldFolderId
      });
      if (result.errorCode === 0) {
        this.list = this.list.filter(m => {
          return !trueList.includes(m.docId);
        });

        this.rowCount = this.rowCount - trueList.length;
        this.$message({
          message: "移动成功",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
      }
    },
    newDocument() {
      this.isShowNew = false;
      alert(this.documentName);
    },
    cancelNewDocument() {
      this.isShowNew = false;
      alert(this.documentName);
    },

    async deleteDoc(docId) {
      var result = await this.ADocDel({ docIdList: docId });
      if (result.errorCode === 0) {
        this.list = this.list.filter(m => m.docId != docId);
        this.rowCount--;
        this.$message({
          message: "已放入到回收站",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "删除失败了",
          type: "error"
        });
      }
    },
    order(timeText) {
      this.timeText = timeText;
      var result = this.time.filter(m => m.name == timeText)[0].text;
      this.sortColumn = result.split("|")[0];
      this.sortType = result.split("|")[1];
      this.getList(1);
    },
    async getFolder() {
      var result = await this.AFolder({ pageSize: 0 });
      this.folder = result.data.dataSource;
    },
    async batchdelete() {
      var trueList = [];
      this.list.forEach(m => {
        if (m.ischecked == true) {
          trueList.push(m.docId);
        }
      });
      if (trueList.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择需要删除的文集",
          type: "warning"
        });
        return;
      }
      var docIdList = trueList.join("|");
      var result = await this.ADocDel({ docIdList: docIdList });
      if (result.errorCode === 0) {
        this.list = this.list.filter(m => !trueList.includes(m.docId));
        this.rowCount--;
        this.$message({
          message: "已放入到回收站",
          type: "success",
          showClose: true
        });
      } else {
        this.$message({
          showClose: true,
          message: "删除失败了",
          type: "error"
        });
      }
    }
  },
  async mounted() {
    // let user = Cookies.get("5ceinfo");
    // if (!user || !JSON.parse(user).token) {

    // var folderResult = await this.AFolder();
    // // alert(1);
    // await this.setfolder(folderResult.data);

    await this.getList(1);

    let getid = setInterval(() => {
      let getBox = document.getElementsByClassName("document-content-list")[0];
      if (getBox) {
        clearInterval(getid);
        this.getHotLineHeight(
          this.contentHeight,
          "document-content-list",
          32,
          "class"
        );
      }
    }, 500);
    this.$refs.order.appendChild(this.$refs.orderdrop.popperElm);
    this.$refs.folder.appendChild(this.$refs.folderdrop.popperElm);
    // }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/style/color";
@import "../assets/style/config";
@import "../assets/style/mixin";

.app-course {
  color: #216bed;
  position: absolute;
  top: 8px;
  right: 0px;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 0px;
}

/deep/.el-input--small .el-input__icon {
  line-height: 30px;
}

.document-content {
  margin-left: 9px;
  margin-right: 9px;
  //搜索框
  .document-search {
    width: 320px;
  }
  //导航
  .document-nav {
    margin: 18px 0 9px;
    .document-nav-left {
      .doc-name {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(102, 102, 102, 1);
        line-height: 36px;
      }
    }
    .document-nav-right {
      font-size: @font-size12;
      line-height: 36px;
      .border {
        padding: 5px 10px;
        height: 24px;
        border: 1px solid rgba(153, 153, 153, 1);
        border-radius: 14px;
      }
      .defaultsize {
        color: rgba(153, 153, 153, 1);
        font-size: @font-size12;
        font-weight: 300;
      }
      .selectall {
        width: 47px;
        height: 12px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
      }
      .batchdelete:hover {
        background-color: #0f58f5;
        color: white;
        height: 24px;
        border: 1px solid #0f58f5;
        border-radius: 14px;
      }
      .move:hover .defaultsize {
        color: white;
      }
      .order-active:hover {
        background-color: #0f58f5;
        border: 1px solid #0f58f5;
        border-radius: 14px;
      }
      .order-active:hover .defaultsize {
        color: white;
      }
      .move:hover {
        background-color: #0f58f5;
        border: 1px solid #0f58f5;
        height: 24px;
        border-radius: 14px;
      }
      .move:hover .defaultsize {
        color: white;
      }
      .order-item {
        background-color: red;
      }
    }
  }
  .document-content-list {
    overflow: auto;
    height: 100%;
  }

  // .document-content-list {
  //   display: flex;
  //   flex-wrap: wrap;
  //   .el-col {
  //     padding-left: 0px !important;
  //     padding-right: 0px !important;
  //     flex-grow: 0;
  //     flex-shrink: 0;
  //     width: calc(20% - 20px);
  //     margin: 10px;
  //     text-align: center;
  //     .document-box {
  //       width: auto;
  //       margin-bottom: 0px !important;
  //       .empty {
  //         width: auto !important;
  //       }
  //     }
  //   }
  // }
  .el-pagination {
    white-space: nowrap;
    padding: 20px 5px;
    color: #303133;
    font-weight: 700;
  }
  .login-tip {
    margin: 20px 0;
  }
  .dialog-tologin {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-document .dialog-title {
    font-size: 14px;
  }
  //删除文集弹窗
  .dialog-delete {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-delete-document .dialog-title {
    font-size: 14px;
  }
  .dialog-delete-document .confirm-delete-title {
    color: red;
    font-size: 20px;
    padding: 10px;
  }
  .dialog-delete-document .confirm-delete-info {
    font-size: 12px;
  }
  .document-count {
    color: @color999;
    font-size: 12px;
  }

  //新建文集
  .documentName {
    width: 80%;
    padding: 15px 0;
  }

  .dialog-newDocument {
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 8px 20px;
  }
  .dialog-newDocument-cancle {
    background-color: #e2e2e2;
    border-radius: 20px;
    padding: 8px 20px;
  }
  /deep/.el-input__inner {
    background-color: rgba(224, 230, 246, 1);
  }
  /deep/.el-input__inner::placeholder {
    color: #94a9ca;
  }
}
.document-new-dialog {
  width: 360px;
  //新增文集
  .document-new-dialog .el-dialog__header {
    padding: 15px;
    border-bottom: 1px solid #f4f4f4;
  }
  .document-new-dialog .el-dialog__body {
    padding: 5px;
  }
  .documentName .el-input__inner {
    border-radius: 20px;
  }
}

/deep/ .el-popper .popper__arrow::after {
  width: 8px;
  height: 8px;
  border-top: 1px solid #215df7 !important;
  border-left: 1px solid #215df7 !important;
  top: 1px !important;
  margin-left: -5px !important;
  transform: rotate(45deg) !important;
  background-color: white;
  border: 0;
}
.el-dropdown-menu {
  margin-right: -17px;
  border-color: #215df7;
  .el-dropdown-menu__item:hover {
    background-color: #f5f8ff;
    color: #0f58f5;
  }
}
</style>

<style lang="less">
.document-dialog .el-dialog__header {
  padding: 15px;
  border-bottom: 1px solid #f4f4f4;
}
.document-dialog .el-dialog__body {
  padding: 5px;
}
//删除文集弹窗
.dialog-delete-document .el-dialog__header {
  padding: 15px;
  border-bottom: 1px solid #f4f4f4;
}
.dialog-delete-document .el-dialog__body {
  padding: 5px;
}
.orderItemActive {
  //background-color: red;
  background-color: #f5f8ff;
  color: #0f58f5;
}

.el-input--mini .el-input__icon {
  line-height: 25px;
}

// .el-popper .popper__arrow::after {
//   width: 8px;
//   height: 8px;
//   border-top: 1px solid #215df7 !important;
//   border-left: 1px solid #215df7 !important;
//   top: 1px !important;
//   margin-left: -5px !important;
//   transform: rotate(45deg) !important;
//   background-color: white;
//   border: 0;
// }
</style>
